export const Type = {
  SET_HOVER_DATA: "FAERUN_SET_HOVER_DATA",
  UPDATE_HOVER_DATA: "FAERUN_UPDATE_HOVER_DATA",
};

export const setHoverData = (indicator, point) => ({ type: Type.SET_HOVER_DATA, data: { indicator, point }});

export const updatePointData = data => ({ type: Type.UPDATE_HOVER_DATA, data });
